module.exports = "/_next/static/images/CollectUserEventData-1470deaeda720a0dbdef63b0bf4794f1.webp";